import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export const LoadingIndicator = () => {
  return (
    <Box
      data-testid="auth-loading"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      <CircularProgress />
    </Box>
  )
}
